// src/components/SmartImg.jsx
import React from "react";
import { buildSrc, buildSrcSet } from "../services/images";

export default function SmartImg({
  src,
  alt = "",
  className = "",
  width = 640,
  height = 360,
  priority = false, // eager for above-the-fold
  sizes = "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 640px",
  q = 75,
}) {
  const fallback = buildSrc(src, { w: width, q, fmt: "webp" });

  return (
    <picture>
      {/* Try AVIF, then WebP, then fallback */}
      <source srcSet={buildSrcSet(src, undefined, { q, fmt: "avif" })} type="image/avif" />
      <source srcSet={buildSrcSet(src, undefined, { q, fmt: "webp" })} type="image/webp" />
      <img
        src={fallback}
        srcSet={buildSrcSet(src, undefined, { q, fmt: "webp" })}
        sizes={sizes}
        alt={alt}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        fetchPriority={priority ? "high" : "auto"}
        width={width}
        height={height}
        className={className}
      />
    </picture>
  );
}
